// extracted by mini-css-extract-plugin
export default {"card":"feature-card_card__LorDk","icon":"feature-card_icon__fd6sT","textContainer":"feature-card_textContainer__8ZiBI","title":"feature-card_title__AOV-1"};